export default "__VITE_ASSET__CJiMdIyA__"